import CompanyIcon from '@acorn-portal/shared/src/assets/shared/icons/base/scales.svg?react';
import { DISPLAY_DATE } from '@acorn-portal/shared/src/utils/constants';
import { Box, Typography } from '@mui/material';
import { format, parseISO } from 'date-fns';
import { FC } from 'react';

interface IVehicle {
	organisationName?: string;
	dateEstablished: string;
	primaryContact?: string;
}

const Organisation: FC<IVehicle> = ({ primaryContact, dateEstablished, organisationName }) => {
	return (
		<Box>
			<Box sx={{ display: 'flex' }}>
				<Box sx={{ width: '65px', marginRight: '3em' }}>
					<CompanyIcon />
				</Box>
				<Box>
					<Typography
						sx={{
							fontSize: 20,
							fontWeight: 'bold',
							textTransform: 'uppercase',
						}}
					>
						{organisationName}
					</Typography>
					<Typography>Established {format(parseISO(dateEstablished), DISPLAY_DATE)}</Typography>
					<Box sx={{ my: 1 }}>
						<Typography fontWeight='bold'>Primary Contact</Typography>
						<Typography>{primaryContact}</Typography>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export default Organisation;
